import { render, staticRenderFns } from "./direction.vue?vue&type=template&id=09015d20&scoped=true&"
import script from "./direction.vue?vue&type=script&lang=js&"
export * from "./direction.vue?vue&type=script&lang=js&"
import style0 from "./direction.vue?vue&type=style&index=0&id=09015d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09015d20",
  null
  
)

export default component.exports